import React from "react";
import { CheckCircle2Icon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { Countdown } from "../Countdown";
import { images } from "../../data/landing";
export function FinalCTA() {
  return <section className="bg-navy px-4 py-16 text-white sm:py-20" data-id="element-141" data-mp="3msz1ryycn1wx">
      <div className="mx-auto max-w-2xl text-center" data-id="element-142" data-mp="3rslg6bpwyo7b">
        <h2 className="font-display text-3xl font-extrabold leading-tight sm:text-4xl" data-id="element-143" data-mp="3rr0l8kzot38x">
          Ready to stop passively consuming information… <em className="italic text-sky" data-id="element-144" data-mp="3hufe9u43xi2g">and start practicing your case analysis?</em>
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-[17px] leading-relaxed text-white/80" data-id="element-145" data-mp="33v5y2ufwinyh">
          You don't need another 20-hour lecture. You need a case. A framework. A few focused questions. And a reason to sit down and think.
        </p>

        <img src={images.mockup} alt="Liposuction Case Lab™ bundle" className="mx-auto mt-8 w-full" loading="lazy" data-id="element-146" data-mp="124ujfh3it94q" />

        <p className="mt-6 font-display text-7xl font-black leading-none" data-id="element-147" data-mp="171uoppsjq7us">$27</p>
        <ul className="mx-auto mt-5 grid max-w-md grid-cols-2 gap-2 text-left text-sm font-semibold" data-id="element-148" data-mp="q7c42oexm28e">
          {["6 Volumes + 5 Bonuses", "Instant digital access", "Lifetime access", "7-day guarantee"].map(t => <li key={t} className="flex items-center gap-1.5" data-id="element-149" data-mp="z05m2tlrjfpy">
              <CheckCircle2Icon className="h-4 w-4 shrink-0 text-cta" aria-hidden="true" data-id="element-150" data-mp="uz3osibepdqm" />
              {t}
            </li>)}
        </ul>
        <div className="mt-8" data-id="element-151" data-mp="7bvjw1hw46p4">
          <CTAButton label="Start your Liposuction Case Lab™" caption="One-time payment of $27 · Local currency converted automatically · 7-day guarantee" dark data-id="element-152" data-mp="2b7rbbe0jhss" />
        </div>
        <Countdown dark data-id="element-153" data-mp="babaefd6jx7a" />
      </div>
    </section>;
}